import TextAlign from '@tiptap/extension-text-align'
import Link from '@tiptap/extension-link'
import Image from '@tiptap/extension-image'
import { TextStyle } from '@tiptap/extension-text-style'
import { Color } from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import { Content, EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

interface TiptapViewerParams {
    content: Content;
}

const TiptapViewer = ({
    content
}: TiptapViewerParams) => {
    const editor = useEditor({
        editable: false, // important: read-only!
        extensions: [
            StarterKit,
            TextAlign.configure({
                types: ['heading', 'paragraph'],
            }),
            Link.configure({
                openOnClick: false,
                HTMLAttributes: {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                },
            }),
            Image.extend({
                addAttributes() {
                    return {
                        ...this.parent?.(),
                        width: {
                            default: null,
                            renderHTML: attributes => {
                                if (!attributes.width) {
                                    return {};
                                }
                                return {
                                    width: attributes.width,
                                    style: `max-width: 100%; width: ${attributes.width}px; height: auto;`,
                                };
                            },
                        },
                    };
                },
            }).configure({
                inline: true,
                allowBase64: true,
                HTMLAttributes: {
                    class: 'tiptap-viewer-image',
                    style: 'max-width: 100%; height: auto;',
                },
            }),
            TextStyle,
            Color,
            Highlight.configure({
                multicolor: true,
            }),
        ],
        content,
    })

    if (!editor) return null

    return <EditorContent editor={editor} />
};

export default TiptapViewer;
